import DataTable from "../../components/DataTable";
import StakeTokens from "../../components/StakeTokens";
import StakedDetails from "../../components/StakedDetails";
import NFTStatus from "../../components/NFTStatus";
import Style from "./style";
import { AppContext } from "../../scripts/context";
import { useContext } from "react";
import PageTitle from "../../components/PageTitle";
import AlertBox from "../../components/AlertBox";

const HOW_TO_CONNECT_META_MASK =
  "https://medium.com/theta-network/theta-blockhain-now-accessible-through-metamask-plug-in-61b278633264#:~:text=If%20you%20send%20tokens%20to,Metamask%2C%20they%20may%20be%20lost.&text=Your%20Metamask%20extension%20should%20now,keystore%20file%20or%20private%20key";
const INSTALL_METAMASK = "https://metamask.io/download";

export default function LPStake() {
  const { state } = useContext(AppContext);
  const checkNetWork = state.netWork
    ? typeof state.netWork.chainId === "number"
      ? state.netWork.chainId
      : parseInt(state.netWork.chainId, 16)
    : false;

  if (checkNetWork && checkNetWork !== Number(process.env.REACT_APP_CHAIN_ID)) {
    return (
      <div className="container">
        <AlertBox type="error">
          <h3>Invalid Network</h3>
          <div>
            <p>
              This system support Theta Chain Only. Please switch to{" "}
              {process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL} network.
            </p>
            <button className="action-button" onClick={state.connectWallet}>
              Connect to a Wallet
            </button>
          </div>
        </AlertBox>
      </div>
    );
  }
  if (
    !state.user.address ||
    state.netWork?.chainId !== Number(process.env.REACT_APP_CHAIN_ID)
  ) {
    return (
      <div className="container">
        <AlertBox type="error">
          <h3>You must connect your wallet</h3>
          <div>
            <p>
              {window.ethereum ? (
                <a
                  href={HOW_TO_CONNECT_META_MASK}
                  target="_blank"
                  rel="noreferrer"
                  className="how-to-use-metamask"
                >
                  How to use metamask
                </a>
              ) : (
                <a
                  href={INSTALL_METAMASK}
                  target="_blank"
                  rel="noreferrer"
                  className="how-to-use-metamask"
                >
                  install metamask
                </a>
              )}
            </p>
            <button className="action-button" onClick={state.connectWallet}>
              Connect to a Wallet
            </button>
          </div>
        </AlertBox>
      </div>
    );
  }

  return (
    <Style>
      <div className="container">
        {state.contracts.staking.data.transactionsList.length > 0 &&
        !state.contracts.staking.data.stakeAgain ? (
          <>
            <PageTitle text="Stake LP tokens to earn" />
            <div className="row staking-row">
              <div className="col-md-7">
                <StakedDetails />
                {/* ) : (
              <>
                <p>khaled</p>
                <StakeTokens />
              </>
            )} */}
              </div>

              <div className="col-md-5 size-small">
                <NFTStatus />
              </div>
            </div>
            {state.contracts.staking.data.transactionsList.length > 0 &&
              !state.contracts.staking.data.stakeAgain && <DataTable />}
          </>
        ) : (
          <>
            <div className="row">
              <AlertBox type="error" className="StakingOverAlertType">
                <h3 className="StakingOverAlert">
                  Staking
                  <br /> IS Over
                </h3>
              </AlertBox>
            </div>
          </>
        )}
      </div>
    </Style>
  );
}
